import React from 'react'
import { useUnifiedAuth } from '../../auth/AuthProvider'
import { Button } from '../atoms/Button'

interface LogoutButtonProps {
  className?: string
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ className = '' }) => {
  const { logout, isAuthenticated } = useUnifiedAuth()

  if (!isAuthenticated) {
    return null
  }

  const handleLogout = () => {
    logout({ 
      logoutParams: {
        returnTo: window.location.origin 
      }
    })
  }

  return (
    <Button
      onClick={handleLogout}
      variant="ghost"
      className={`min-w-24 px-4 ${className}`}
      data-testid="logout-button"
    >
      <div className="flex items-center">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span className="ml-2 text-sm hidden sm:inline">
          Logout
        </span>
      </div>
    </Button>
  )
} 